module.exports = __webpack_public_path__ + "img/bg-matching1.30a3cd2a.png";